// External imports
import { useStep } from './StepContext';
import { useTranslation } from 'react-i18next';

// Components
import Checkout from '../Checkout/Checkout';
import Location from '../Location/ChooseLocation';
import UserDetailsPage from '../UserDetails/UserDetails';
import BookingPeriod from '../BookingPeriod/BookingPeriod';
import ContainerSizeSelect from '../ContainerBooking/SizeSelection/ContainerSizeSelect';
import Confirmation from '../Confirmation/Confirmation';
import ArrowRightIcon from '../Icons/ArrowRightIcon';

export default function BookingWizard({ sessionId }) {
  const { t } = useTranslation();
  const { activeStep, isFirstStep, isLastStep, handlePrev } = useStep();

  return (
    <>
      <div className="w-full">
        <div className="w-full justify-center items-center flex flex-col">
          <div className="w-full">
            {!isFirstStep && !isLastStep && (
              <div
                className="flex items-center cursor-pointer"
                onClick={() => {
                  handlePrev();
                }}
              >
                <div className="rotate-180">
                  <ArrowRightIcon className="size-6" />
                </div>
                <div>{t('back')}</div>
              </div>
            )}
          </div>

          {activeStep === 0 && <Location />}
          {activeStep === 1 && <ContainerSizeSelect />}
          {activeStep === 2 && <BookingPeriod />}
          {activeStep === 3 && <UserDetailsPage />}
          {activeStep === 4 && <Confirmation />}
          {activeStep === 5 && <Checkout sessionId={sessionId} />}
        </div>
      </div>
    </>
  );
}
